module.exports = __webpack_public_path__ + "static/assets/e84526d3b31e843b84ed0ff401f0f8ac.svg";